import { DeepPartial, AppConfig } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
    // Ejemplo
     pages: {
         login: {
             title: 'Iniciar sesión',
         },
         users: {
            titlePlural: 'Usuarios',
            titleSingular: 'Usuario',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                image: {
                    label: 'Imagen',
                    placeholder: 'Selecciona una imagen'
                },
                rol: {
                    label: 'Asignar rol',
                    placeholder: 'Selecciona....'
                },
                agency: {
                    label: 'Agencia',
                    placeholder: 'Seleccionar agencia....'
                }
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                bussiness: {
                    label: 'Empresa',
                    placeholder: 'Escribir...'
                },
            },
        },
        agency: {
            titlePlural: 'Agencias',
            titleSingular: 'Agencia',
            form: {
                name: {
                    label: 'Nombre de la agencia ',
                    placeholder: 'Ingresa tu nombre..'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Ingresa dirección...'
                },
                phone: {
                    label: 'Telefono',
                    placeholder: 'Ingresa telefono...'
                },
                business: {
                    label: 'Empresa',
                    placeholder: 'Ingresa nombre de empresa...'
                },
                latitude: {
                    label: 'Latitude',
                    placeholder: 'Latitude....'
                },
                longitude: {
                    label: 'Longitude',
                    placeholder: 'Longitude....'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa descripción....'
                }
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
            }

        },
        customer: {
            titlePlural: 'Clientes',
            titleSingular: 'Cliente',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                code: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa contraseña'
                },
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                initial_date: {
                    label: 'Fecha inicio',
                    placeholder: 'Ingresa fecha inicio'
                },
                end_date: {
                    label: 'Fecha fin',
                    placeholder: 'Ingresa fecha fin'
                },
            }
        },
         profile: {
            titlePlural: 'Perfiles',
            titleSingular: 'Perfil',
            form:{
                name: {
                    label: 'Nombre',
                    placeholder: 'Escribir nombre'
                },
                last_name: {
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Escribir celular...'
                },
                birth_date: {
                    label: 'Fecha de nacimiento',
                    placeholder: 'Escribir Fecha de nacimiento...'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Escribir ciudad...'
                },
                country: {
                    label: 'País',
                    placeholder: 'Escribir paós...'
                },
                ci:{
                    label: 'Carnet',
                    placeholder: 'Ingrese...'
                },
            },
            form_filter: {
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero carnet'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir...'
                },
                city:{
                    label: 'Ciudad',
                    placeholder: 'Escribir...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar...'
                },

            }
        },

        historyTickets: {
            titlePlural: 'Reportes de entradas',
            titleSingular: 'Reporte de entrada',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar código',
                    placeholder: 'Escribir código...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero de carnet...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir fecha inicio...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir fecha fin...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar evento...'
                },
                type:{
                    label: 'Tipo de reserva',
                    placeholder: 'Seleccionar...'
                },
            }
        },
        sendMail: {
            titlePlural: 'Correos enviados',
            titleSingular: 'Correo enviado',
            form:{},
            form_filter: {
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                status:{
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
                token:{
                    label: 'Buscar por token',
                    placeholder: 'Escribir...'
                },
            }
        },
        salesReport: {
            titlePlural: 'Reportes de ventas',
            titleSingular: 'Reporte de venta',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar código',
                    placeholder: 'Escribir código...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero de carnet...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir fecha inicio...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir fecha fin...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar evento...'
                },
            }
        },
        assistance: {
            titlePlural: 'Asistencias',
            titleSingular: 'Asistencia',
            form:{},
        },
        seats: {
            titlePlural: 'Reporte de asientos',
            titleSingular: 'Reporte de asiento',
            form:{},
        },
        roles: {
            titlePlural: 'Roles',
            titleSingular: 'Rol',
            form: {
                name: {
                    label: 'Nombre del rol',
                    placeholder: 'Ingresar nombre...'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa, descripción y alcance del rol...'
                },
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                initial_date: {
                    label: 'Fecha inicio',
                    placeholder: 'Ingresa fecha inicio'
                },
                end_date: {
                    label: 'Fecha fin',
                    placeholder: 'Ingresa fecha fin'
                },
            }
        },
        permissions: {
            titlePlural: 'Permisos',
            titleSingular: 'Permiso',
            form: {
                name: {
                    label: 'Nombre del permisio',
                    placeholder: 'Ingresar nombre...'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa, descripción y alcance del rol...'
                },
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                initial_date: {
                    label: 'Fecha inicio',
                    placeholder: 'Ingresa fecha inicio'
                },
                end_date: {
                    label: 'Fecha fin',
                    placeholder: 'Ingresa fecha fin'
                },
            }
        },
        templea: {
            titlePlural: 'Plantillas',
            titleSingular: 'Plantilla',
            form:{
                name: {
                    label: 'Titulo de la plantilla',
                    placeholder: 'Escribir...'
                },
                type: {
                    label: 'Tipo de plantilla',
                    placeholder: 'Seleccionar...'
                },
                typeNotification: {
                    label: 'Tipo notificacción',
                    placeholder: 'Seleccionar...'
                },
                description: {
                    label: 'Contenido',
                    placeholder: 'Escribir...'
                },
            },
            form_filter: {}
        },
        sendMailCustom: {
            titlePlural: 'Enviar correos',
            titleSingular: 'Enviar correo',
            form:{
                title: {
                    label: 'Titulo',
                    placeholder: 'Escribir titulo...'
                },
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                segment:{
                    label: 'Segmento de usuarios',
                    placeholder: 'Seleccionar...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir Correo electrónico...'
                },
                link:{
                    label: 'Link de ticket',
                    placeholder: 'Escribir link...'
                },
                content:{
                    label: 'Contenido',
                    placeholder: 'Escribir texto del correo...'
                },
                template_id:{
                    label: 'Plantilla',
                    placeholder: 'Seleccionar...'
                },

                image:{
                    label: 'Imagen',
                    placeholder: 'Escribir...'
                },
                name:{
                    label: 'Nombre del evento',
                    placeholder: 'Escribir...'
                },
                stage:{
                    label: 'Nombre del predio',
                    placeholder: 'Escribir...'
                },
                date:{
                    label: 'Fecha del evento',
                    placeholder: 'Escribir...'
                },
                time:{
                    label: 'Hora del evento',
                    placeholder: 'Escribir...'
                },
                order:{
                    label: 'Orden',
                    placeholder: 'Escribir...'
                },
                quantity:{
                    label: 'Cantidad',
                    placeholder: 'Escribir...'
                },
                city:{
                    label: 'Ciudad',
                    placeholder: 'Escribir...'
                },
            },
            form_filter: {
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                status:{
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
                token:{
                    label: 'Buscar por token',
                    placeholder: 'Escribir...'
                },
            }
        },

     },

    menu: [
        {
            headTitle1: "General",
            permissions:'default',
        },
        {
            id: 1,
            level: 1,
            path: '/account',
            title: "Mi Cuenta",
            icon: "home",
            type: "link",
            permissions:'default',
        },
        {
            id: 1,
            level: 1,
            path: '/event',
            title: "Administrador de Eventos",
            icon: "home",
            type: "link-external-admin",
            permissions:'organization-page-ticket',
        },
        {
            headTitle1: "Usuarios",
            permissions:'default',
        },
        {
            id: 2,
            level: 1,
            path: '/users',
            title: "Usuarios del admin",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-users',
        },
        {
            id: 3,
            level: 1,
            path: '/profile',
            title: "Perfiles",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-profiles',
        },
        {
            id: 4,
            level: 1,
            path: '/customer',
            title: "Clientes",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-customers',
        },
        {
            id: 5,
            level: 1,
            path: '/agency',
            title: "Agencia",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-agency',
        },

        /* {
            headTitle1: "Predios",
            permissions:'default',
        },
        {
            id: 2,
            level: 1,
            path: '/location/create',
            title: "Crear predios",
            icon: "bookmark",
            type: "link-external-admin",//link-external-admin,link,extTabLink
            permissions: 'default'
        },
        {
            id: 3,
            level: 1,
            path: '/location',
            title: "Predios habilitados",
            icon: "bookmark",
            type: "link-external-admin",//link-external-admin, link, extTabLink
            permissions: 'default'
        },
        {
            id: 4,
            level: 1,
            path: '/location/list-archived',
            title: "Predios archivados",
            icon: "bookmark",
            type: "link-external-admin",//link-external-admin, link, extTabLink
            permissions: 'default'
        }, */
        {
            headTitle1: "Tickets",
            permissions:'default',
        },
        {
            id: 5,
            level: 1,
            path: 'history-tickets',
            title: "Reportes de entradas",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-history_tickets',
        },
        {
            id: 5,
            level: 1,
            path: 'assistance',
            title: "Reporte de asistencia",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-assistance',
        },
        {
            id: 5,
            level: 1,
            path: 'report-seats',
            title: "Reporte de Asientos",
            icon: "bookmark",
            type: "link",
            permissions:'defaultt',
        },
        {
          headTitle1: "Roles y Premios",
          permissions: 'organization-title-permission',
        },
        {
          id: 10,
          level: 1,
          path: '/roles',
          title: "Roles",
          icon: "bookmark",
          type: "link",
          permissions:'organization-page-roles',
        },
        {
          id: 11,
          level: 1,
          path: '/permissions',
          title: "Permisos",
          icon: "bookmark",
          type: "link",
          permissions:'organization-page-permission',
        },
        {
          headTitle1: "Notificaciones",
          permissions:'admin-tag-notification',
        },
        {
          id: 6,
          level: 1,
          path: 'templates',
          title: "Plantilla",
          icon: "bookmark",
          type: "link",
          permissions:'notification-page-template',
        },
        {
          id: 11,
          level: 1,
          path: '/batches',
          title: "Lotes",
          icon: "bookmark",
          type: "link",
          permissions:'notification-page-batches',
        },
        {
          id: 11,
          level: 1,
          path: '/shedules',
          title: "Notificaciones programadas",
          icon: "bookmark",
          type: "link",
          permissions:'notification-page-shedules',
        },
        {
          id: 5,
          level: 1,
          path: 'send-email',
          title: "Notificaciones Enviadas",
          icon: "bookmark",
          type: "link",
          permissions:'notification-page-send_email',
        },
        {
          headTitle1: "Diseño de Plantillas",
          permissions: 'admin-tag-credential',
        },
        {
          id: 11,
          level: 1,
          path: '/credentials',
          title: "Diseño de Plantillas",
          icon: "bookmark",
          type: "link",
          permissions:'credential-page-credential',
        },
    ]
};
